/**
 * Cart Page Constants
 * Centralized configuration for cart-related features
 */

// Category order for cart display
export const CART_CATEGORY_ORDER = [
  'Plywood', 'Blockboard', 'Laminates', 'Doors', 'WPC/PVC', 
  'Veneers', 'Highlighters', 'MDF', 'ACP', 'Hardware', 'Adhesives', 'Others'
];

// Category display names (for cart subheadings)
export const CART_CATEGORY_DISPLAY_NAMES = {
  'Hardware': 'NAILS / SCREWS / HARDWARE',
  'WPC/PVC': 'WPC / PVC'
};

// Default quick add states
// NOTE: size defaults to empty string so the Quick Add dialogs show empty
// W × H boxes — user types whatever they need (feet / mm / inches) or
// leaves blank. Defaulting to "8x4" would force a size on items that don't
// have one (hardware, adhesives) and unexpectedly trigger sqft expansion.
export const DEFAULT_CART_VENEER_QUICK_ADD = {
  species: '',
  product_code: '',
  size: '',
  rate: '',
  quantity: 1,
  // Veneer is almost always priced per square foot — and the user enters
  // quantity in SHEETS, so we treat the rate as per-sqft and multiply by
  // sheet area at apply time. Override to 'sheet' / 'piece' if the rate is
  // already a per-sqft flat price.
  uom: 'sqft',
  unit: 'SHEET',
  // Brand visibility is HIDDEN by default — user has to explicitly tick
  // the toggle if they want the brand to show on the customer PDF.
  // Internal PDF always shows the brand regardless.
  show_brand: false,
};

export const DEFAULT_CART_LAMINATE_QUICK_ADD = {
  brand: '',
  product_code: '',
  // Renamed from `finish` per user request — staff types whatever short
  // descriptor they want here (e.g. "Matte", "Backlit", "Walnut Burl").
  // Shows FIRST in the composed PDF line, before the code.
  description: '',
  // NEW — appears third in the composed PDF line: "<description> -
  // <code> - <thickness>". Optional.
  thickness: '',
  rate: '',
  size: '',
  category: 'Laminates',
  quantity: 1,
  uom: 'sheet',   // 'sqft' | 'sheet' | 'piece' — controls rate × size math
  show_brand: false,
};

export const DEFAULT_CART_HARDWARE_QUICK_ADD = {
  brand: '',
  product_name: '',
  product_code: '',
  specs: '',
  size: '',
  rate: '',
  rate_type: 'per set',
  quantity: 1,
  show_brand: false,
};

export const DEFAULT_CART_ADHESIVE_QUICK_ADD = {
  brand: '',
  product_name: '',
  product_code: '',
  weight: '1KG',
  size: '',
  rate: '',
  quantity: 1,
  show_brand: false,
};

// Laminate Quick Add UOM options. "sqft" multiplies rate × (H×W in sqft) × qty.
// "sheet" and "piece" treat rate as the line total per unit (rate × qty).
export const LAMINATE_UOM_OPTIONS = [
  { value: 'sheet', label: 'Per Sheet' },
  { value: 'sqft', label: 'Per Sq Ft' },
  { value: 'piece', label: 'Per Piece' },
];

// Preset room/section names
export const PRESET_SECTIONS = [
  "Living Room", 
  "Master Bedroom", 
  "Son's Bedroom", 
  "Daughter Bedroom", 
  "Kids Bedroom", 
  "Kitchen", 
  "Mandir"
];

// Veneer species suggestions
export const VENEER_SPECIES_SUGGESTIONS = [
  'Walnut', 'American Walnut', 'Teak', 'Oak', 'White Oak', 
  'Red Oak', 'Smoked Oak', 'Ash', 'Maple', 'Cherry', 
  'Mahogany', 'Rosewood', 'Ebony', 'Sapele', 'Wenge', 
  'Zebrano', 'Engineered', 'Hybrid'
];

// Adhesive weight options
export const ADHESIVE_WEIGHTS = [
  '500GMS', '1KG', '5KG', '10KG', '20KG', '50KG'
];

// Rate type options
export const HARDWARE_RATE_TYPES = [
  { value: 'per set', label: 'Per Set' },
  { value: 'per piece', label: 'Per Piece' },
  { value: 'per pair', label: 'Per Pair' }
];

// Laminate size options
export const LAMINATE_SIZES = ['8x4', '9x4', '10x4', '12x4'];

// Veneer size options
export const VENEER_SIZES = [
  { value: '8x4', label: '8 x 4' },
  { value: '10x4', label: '10 x 4' },
  { value: '7x4', label: '7 x 4' },
  { value: '6x4', label: '6 x 4' }
];

// Veneer unit options
export const VENEER_UNITS = [
  { value: 'SQ FT', label: 'SQ FT' },
  { value: 'SHEET', label: 'SHEET' },
  { value: 'NOS', label: 'NOS' }
];
